<p-checkbox class="mr-2" [ngModel]="_value > 0" [binary]="true" (ngModelChange)="change($event)"></p-checkbox>
@if (_value > 0) {
  <p-badge class="mouse-pointer" [class.greyed]="_value == 1" [value]="'' + _value" (click)="click()"></p-badge>
}
